module.exports = __webpack_public_path__ + "static/img/ls23.71f09fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls23.png
// module id = RGR9
// module chunks = 12